import {
  Stack,
  InputAdornment,
  inputBaseClasses,
  outlinedInputClasses, useTheme, Typography, Switch
} from '@mui/material'
import React, {useEffect, useState,useMemo} from "react";
import AppTextField from '@/components/AppTextField';
import RpIcon from "@/components/RpIcon";

import AssetsService from "@/services/assets";
import { useRequest } from "ahooks";
import theme from "@/redux/slices/theme";
import {getNationIcon, getNationIconByCode2} from "@/utils/utils";
import {useSelector} from "react-redux";
import {orderBy, sortBy} from "es-toolkit/array";
import { StyledSwitch } from "@/styles/CommonStyledComponents";

const CurrencyList = (props) => {
  const {checkedCurrencyList, onChange, onLoad} = props

  const [searchText, setSearchText] = useState('')
  const theme = useTheme();
  const [allList, setAllList] = useState([])
  const [list, setList] = useState([])
  const req = useRequest(async () => {
    const res = await AssetsService.getCurrencyList();
    return res
  }, { manual: true });
  const reqJson = useRequest(async () => {
    const res = await AssetsService.getCurrencyListJson();
    return res
  }, { manual: true });

  useEffect(() => {
    req.runAsync()
    reqJson.runAsync()
  }, []);

  useEffect(() => {
    console.log('checkedCurrencyList', checkedCurrencyList)
  }, [checkedCurrencyList]);

  useEffect(() => {
    if (!req.data) return;
    if (!reqJson.data) return;

    let ret = req?.data.list.map((item) => {
      const withFlagCurrency = reqJson?.data.find(_ => {
        return _.code === item.name
      })

      const checkedCurrency = checkedCurrencyList.find(_ => {
        return _.currencyCode == item.name || _.code == item.name
      })

      return {
        ...item,
        ...withFlagCurrency,
        isChecked: checkedCurrency ? true : false
      }
    })

    setAllList(ret)
    if (searchText) {
      ret = ret.filter(_ => _?.country?.toLowerCase().includes(searchText.toLowerCase())
        || _?.code?.toLowerCase().includes(searchText.toLowerCase())
        || _?.fullName?.toLowerCase().includes(searchText.toLowerCase())
      )
    }
    ret = sortBy(ret, [_ => { return !_.isChecked }])

    setList(ret)
  }, [req?.data, reqJson?.data, checkedCurrencyList, searchText]);

  const hangleChange = (e, item) => {
    const checked = e.target.checked;
    let newList = [...list].map(_ => {
      if (_.code === item.code) {
        return {
          ..._,
          isChecked: checked
        }
      }
      return {
        ..._
      }
    })
    // newList = sortBy(newList, [_ => { return !_.isChecked }])
    setList([...newList])
    onChange && onChange(newList)
  }

  useEffect(() => {
    onLoad && onLoad(allList)
  }, [allList]);

  return (
    <Stack direction="column" sx={{
      height: '100%',
      overflow: 'auto'
    }}>
      <AppTextField
        autoComplete="off"
        clearable
        sx={{
          backgroundColor: theme.palette.background.card,
          borderRadius: '32px',
          [`& .${inputBaseClasses.root}`]: {
            paddingLeft: '12px !important',
          },
          [`& .${outlinedInputClasses.notchedOutline}`]: {
            borderWidth: '0px !important',
          }
        }}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <RpIcon icon="search" size={16} />
              </InputAdornment>
            )
          }
        }}
      />
      <Stack >
        {list?.map((item, index) => (
          <Stack sx={{
            height: '70px'
          }} key={index} direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" gap="12px">
              <img
                style={{display: 'block', width: '32px', height: '32px'}}
                src={getNationIconByCode2(item.countryCode)}/>
              <Stack>
                <Typography>{item.code}</Typography>
                <Typography sx={{
                  color: theme.palette.text.tertiary,
                  fontSize: '12px'
                }}>{item.name}</Typography>
              </Stack>
            </Stack>
            <StyledSwitch value={item.code} checked={item.isChecked} onChange={(e) => {
                hangleChange(e, item)
              }} />
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}

export default CurrencyList